/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Proposals API
 * Moment's Proposals API allows Clients to manage optimization proposals.
 * OpenAPI spec version: 1.0.0
 */

/**
 * The status of the bond reflects many possible states a bond can be in.
 *   * called: The bond has been called by the issuer.
 *   * converted: The bond has been converted into another type of security. Usually this is from the issue being converted into common stock.
 *   * defaulted: The bond issuer has failed to make timely payments on the bond and has entered default.
 *   * funged: The bond has been funged (replaced/exchanged) for another. This sometimes happens when an issuer combines two classes of bond into one parent bond.
 *   * liquidated: The issuer has been liquidated.
 *   * matured: The bond has reached its maturity date and the bondholders have been repaid their principal.
 *   * outstanding: The bond is still active and has not reached its maturity date.
 *   * pre_issuance: There is reference data for this bond but it has not yet been issued and is unavailable for trading.
 *   * put: The bond has been put (sold back) to the issuer.
 *   * repaid: The bond has been repaid before its maturity date using a covenant other than an option such as a put or call. For example, through prepayment.
 *   * tendered: The bond has been tendered (offered for repurchase) by the issuer.
 *   * repurchased: The bond has been repurchased by the issuer.
 *   * restructured: The security has been restructured into a new security or into a security with materially different terms.
 *   * unknown: The status of the bond is unknown.
 */
export type InstrumentStatus = typeof InstrumentStatus[keyof typeof InstrumentStatus];


export const InstrumentStatus = {
  called: 'called',
  converted: 'converted',
  defaulted: 'defaulted',
  funged: 'funged',
  liquidated: 'liquidated',
  matured: 'matured',
  outstanding: 'outstanding',
  pre_issuance: 'pre_issuance',
  put: 'put',
  repaid: 'repaid',
  tendered: 'tendered',
  repurchased: 'repurchased',
  restructured: 'restructured',
  unknown: 'unknown',
} as const;
